import React from "react";
import { useTranslation } from "@helpers/translate";
import "./index.sass";

export const TradingStatsCard = ({ stats }) => {
  const { __ } = useTranslation();

  const {
    totalTrades = 0,
    winRate = 0,
    wins = 0,
    losses = 0,
    tradedVolume = 0,
    realizedPnl = 0,
  } = stats || {};

  const totalResults = wins + losses;

  const winProgressWidth = totalResults ? (wins / totalResults) * 100 : 0;
  const lossProgressWidth = totalResults ? (losses / totalResults) * 100 : 0;

  return (
    <div className="trading-stats-card">
      <div className="trading-stats-card__top">
        <div className="trading-stats-card__metrics">
          <div className="trading-stats-card__metric">
            <div className="trading-stats-card__metric-label">
              {__("trading_profile.total_trades")}
            </div>

            <div className="trading-stats-card__metric-value">
              {totalTrades}
            </div>
          </div>

          <div className="trading-stats-card__metric trading-stats-card__metric--right">
            <div className="trading-stats-card__metric-label">
              {__("trading_profile.win_rate")}
            </div>

            <div className="trading-stats-card__metric-value">{winRate}%</div>
          </div>
        </div>

        <div className="trading-stats-card__metrics">
          <div className="trading-stats-card__metric">
            <div className="trading-stats-card__metric-label">
              {__("trading_profile.trading_volume")}
            </div>

            <div className="trading-stats-card__metric-value">
              $
              {Number(tradedVolume) === 0
                ? 0
                : new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(Number(tradedVolume) || 0)}
            </div>
          </div>

          <div className="trading-stats-card__metric trading-stats-card__metric--right">
            <div className="trading-stats-card__metric-label">
              {__("trading_profile.realized_pnl")}
            </div>

            <div className="trading-stats-card__metric-value">
              {Number(realizedPnl) < 0
                ? `-$${new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(Math.abs(Number(realizedPnl)))}`
                : `$${new Intl.NumberFormat("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }).format(Number(realizedPnl) || 0)}`}
            </div>
          </div>
        </div>
      </div>

      <div className="trading-stats-card__bottom">
        <div className="trading-stats-card__progress-header">
          <span className="trading-stats-card__progress-label">
            {__("trading_profile.win")}
            <span className="trading-stats-card__win"> {wins}</span>
          </span>

          <span className="trading-stats-card__progress-label">
            {__("trading_profile.loss")}
            <span className="trading-stats-card__loss"> {losses}</span>
          </span>
        </div>

        <div className="trading-stats-card__progress">
          <div className="trading-stats-card__progress-track">
            <div
              className="trading-stats-card__progress-win"
              style={{ width: `${winProgressWidth}%` }}
            />

            <div
              className="trading-stats-card__progress-loss"
              style={{ width: `${lossProgressWidth}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TradingStatsCard;
